import { render, staticRenderFns } from "./left-arrow-icon.vue?vue&type=template&id=42444266&scoped=true&lang=pug&"
import script from "./left-arrow-icon.vue?vue&type=script&lang=js&"
export * from "./left-arrow-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42444266",
  null
  
)

export default component.exports